'use client'

import React, { useState, useRef, useEffect } from "react";
import styles from "./Header.module.css";
import logo from "@/assets/logo/BePex_Logo.webp";
import { accordion, OnOpenUrl,OnPreFetchUrl } from "./accordion";
import { useTranslation } from "react-i18next";
import LanguageSelector from "./LanguageSelector";
import SideBar from "./SideBar";
import Image from "next/image";
import { useRouter } from "next/navigation";

const Header = () => {
    const [isHovered, setIsHovered] = useState(false);
    const [isSideBarOpen, setIsSideBarOpen] = useState(false);
    const [isVisible, setIsVisible] = useState(true);
    const lastScrollY = useRef(0);
    const [isAtTop, setIsAtTop] = useState(true);
    const router = useRouter();
    const {t} = useTranslation();
    const handleHover = (isHover) => {
        setIsHovered(isHover);
    };

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;
            if (currentScrollY > lastScrollY.current && currentScrollY > 100) {
                setIsVisible(false);
            } else {
                setIsVisible(true);
            }
            setIsAtTop(currentScrollY <= 10);
            lastScrollY.current = currentScrollY;
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);
    useEffect(() => {
        accordion.map((item, index) => {
            item.content.map((content,index) => {
                OnPreFetchUrl({content : content, navigate:router});
            });    
        });
    }, []);
    return (
        <div
            className={`
        ${styles.header__wrap}
        ${isHovered ? styles.open : ""}
        ${!isVisible ? styles.hidden : ""}
        ${!isAtTop ? styles.scrolled : ""}
      `}
        >
            <div className={styles.header__inner}>
                <header className={styles.header}>
                    <div
                        className={styles.logo}
                        onClick={() => OnOpenUrl({ content: { url: "" }, navigate: router })}
                    >
                        <Image
                            src={logo.src || logo}
                            className={`${styles.logo__image} ${isHovered ? styles.open : ""}`}
                            width={74}
                            height={25}
                            alt="logo"
                        />
                    </div>

                    <div
                        className={styles.nav}
                        onMouseEnter={() => handleHover(true)}
                        onMouseLeave={() => handleHover(false)}
                    >
                        {accordion.map((item, index) => (
                            <nav className={styles.nav__button} key={index}>
                                <div className={styles.nav__title}>
                                            <span className={styles.nav__text} > 
                                            {t(item.nameKey)}
                                            </span>
                                </div>
                                <div className={styles.nav__detail}>
                                    <div className={styles.nav__depth2}>
                                        {item.content.map((content, key) => (
                                            <span
                                                className={styles.nav__depth__text} 
                                                key={key} 
                                                onClick={() => {
                                                        OnOpenUrl({ content: content, navigate: router });
                                                    }}>
                                                {
                                                    t(content.nameKey) 
                                                }
                                                <span className={styles.activeLine}></span>
                                            </span> 
                                        ))}
                                    </div>
                                </div>
                            </nav>
                        ))}
                    </div>
                </header>

                <div className={`${styles.header__line} ${isHovered ? styles.open : ""}`} />

                <SideBar isPanelOpen={isSideBarOpen} onPanelOpen={setIsSideBarOpen} />

                <div className={styles["side-bar"]}>
                    <LanguageSelector isHover={isHovered} />
                    <div
                        className={`${styles["side-bar__close__btn"]} ${isSideBarOpen ? styles.open : ""
                            }`}
                        onClick={() => setIsSideBarOpen(!isSideBarOpen)}
                    >
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default Header;
